import Rest from '@services/Rest';

/**
 * @typedef {WithdrawService}
 */
export default class WithdrawService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/withdraw'
}
